import {combineReducers} from "redux";
import createDraw from "./createDraw";

const createDrawConfigReducer = combineReducers({
    createDraw
});
export default createDrawConfigReducer;